/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  ReplyListApiV1CollaborationAppReplyGetQueryResponse,
  ReplyListApiV1CollaborationAppReplyGetQueryParams,
  ReplyListApiV1CollaborationAppReplyGetHeaderParams,
  ReplyListApiV1CollaborationAppReplyGet422,
} from '../../types/ReplyListApiV1CollaborationAppReplyGet.ts'
import type { InfiniteData, QueryKey, QueryClient, InfiniteQueryObserverOptions, UseInfiniteQueryResult } from '@tanstack/react-query'
import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

export const replyListApiV1CollaborationAppReplyGetInfiniteQueryKey = (params?: ReplyListApiV1CollaborationAppReplyGetQueryParams) =>
  [{ url: '/api/v1/collaboration_app/reply' }, ...(params ? [params] : [])] as const

export type ReplyListApiV1CollaborationAppReplyGetInfiniteQueryKey = ReturnType<typeof replyListApiV1CollaborationAppReplyGetInfiniteQueryKey>

/**
 * @summary Reply List
 * {@link /api/v1/collaboration_app/reply}
 */
export async function replyListApiV1CollaborationAppReplyGetInfinite(
  params?: ReplyListApiV1CollaborationAppReplyGetQueryParams,
  headers?: ReplyListApiV1CollaborationAppReplyGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<ReplyListApiV1CollaborationAppReplyGetQueryResponse, ResponseErrorConfig<ReplyListApiV1CollaborationAppReplyGet422>, unknown>({
    method: 'GET',
    url: `/api/v1/collaboration_app/reply`,
    params,
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  })
  return res.data
}

export function replyListApiV1CollaborationAppReplyGetInfiniteQueryOptions(
  params?: ReplyListApiV1CollaborationAppReplyGetQueryParams,
  headers?: ReplyListApiV1CollaborationAppReplyGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = replyListApiV1CollaborationAppReplyGetInfiniteQueryKey(params)
  return infiniteQueryOptions<
    ReplyListApiV1CollaborationAppReplyGetQueryResponse,
    ResponseErrorConfig<ReplyListApiV1CollaborationAppReplyGet422>,
    ReplyListApiV1CollaborationAppReplyGetQueryResponse,
    typeof queryKey,
    number
  >({
    queryKey,
    queryFn: async ({ signal, pageParam }) => {
      config.signal = signal

      if (params) {
        params['offset'] = pageParam as unknown as ReplyListApiV1CollaborationAppReplyGetQueryParams['offset']
      }
      return replyListApiV1CollaborationAppReplyGetInfinite(params, headers, config)
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => (Array.isArray(lastPage) && lastPage.length === 0 ? undefined : lastPageParam + 1),
    getPreviousPageParam: (_firstPage, _allPages, firstPageParam) => (firstPageParam <= 1 ? undefined : firstPageParam - 1),
  })
}

/**
 * @summary Reply List
 * {@link /api/v1/collaboration_app/reply}
 */
export function useReplyListApiV1CollaborationAppReplyGetInfinite<
  TData = InfiniteData<ReplyListApiV1CollaborationAppReplyGetQueryResponse>,
  TQueryData = ReplyListApiV1CollaborationAppReplyGetQueryResponse,
  TQueryKey extends QueryKey = ReplyListApiV1CollaborationAppReplyGetInfiniteQueryKey,
>(
  params?: ReplyListApiV1CollaborationAppReplyGetQueryParams,
  headers?: ReplyListApiV1CollaborationAppReplyGetHeaderParams,
  options: {
    query?: Partial<
      InfiniteQueryObserverOptions<
        ReplyListApiV1CollaborationAppReplyGetQueryResponse,
        ResponseErrorConfig<ReplyListApiV1CollaborationAppReplyGet422>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? replyListApiV1CollaborationAppReplyGetInfiniteQueryKey(params)

  const query = useInfiniteQuery(
    {
      ...replyListApiV1CollaborationAppReplyGetInfiniteQueryOptions(params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as InfiniteQueryObserverOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, ResponseErrorConfig<ReplyListApiV1CollaborationAppReplyGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}